import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { UserBuilder } from '../../models/builders/user-builder';
import { User } from '../../models/user';

const createUserBody = (user: User) => (
  {
    firstName: user.firstName,
    lastName: user.email,
    email: user.email,
    password: user.password,
    passwordRepeat: user.passwordRepeat
  }
);

@Injectable()
export class UserApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${environment.apiUrl}users`;
  }

  getUser(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
     .pipe(
       map(UserBuilder.fromJson)
    );
  }

  getUsers() {
    return this.httpClient.get(this.apiUrl).pipe(map(UserBuilder.fromJsonList));
  }

  getAuthorizableUsers() {
    return this.httpClient.get(`${ this.apiUrl }/admin`).pipe(map(UserBuilder.fromJsonList));
  }

  createUser(user: User) {
    return this.httpClient.post(`${this.apiUrl}`, createUserBody(user)).pipe(
      map(UserBuilder.fromJson)
    );
  }

  updateUser(user: User) {
    return this.httpClient.put(`${ this.apiUrl }/${ user.hash }`, createUserBody(user));
  }

  deleteUser(userHash: string) {
    return this.httpClient.delete(`${ this.apiUrl }/${ userHash }`);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/api/user-api.service.ts